import { render, staticRenderFns } from "./SettingsTranslationLanguages.vue?vue&type=template&id=74f8d610&"
import script from "./SettingsTranslationLanguages.vue?vue&type=script&lang=ts&"
export * from "./SettingsTranslationLanguages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports